import type { Dispatch } from 'redux';
import {
  startSessionHeartbeatScheduler,
  stopSessionHeartbeatScheduler,
} from '@codametrix/client-session';
import { getSessionHeartbeatIntervalMs } from '@codametrix/client-runtime';
import { authenticationContext, sessionManagement } from '@codametrix/ui-common';
import { dispatchSessionHeartbeatMiss } from './session-heartbeat-miss';

const { activityMonitor } = sessionManagement;

type AuthenticationChannelReady = {
  isChild: boolean;
  ready: Promise<unknown>;
};

export function syncSessionHeartbeatScheduler(dispatch: Dispatch) {
  const contextId = authenticationContext.getContextId();
  if (contextId == null) {
    stopSessionHeartbeatScheduler();
    return;
  }

  const onSessionMiss = () => dispatchSessionHeartbeatMiss(dispatch);
  startSessionHeartbeatScheduler({
    getContextId: () => authenticationContext.getContextId(),
    isUserActive: () =>
      activityMonitor.isActiveSince(Date.now() - getSessionHeartbeatIntervalMs()),
    onSessionMiss,
  });
}

export async function syncChildSessionHeartbeatSchedulerAfterAuth(
  channel: AuthenticationChannelReady,
  dispatch: Dispatch
): Promise<void> {
  if (!channel.isChild) {
    return;
  }

  await channel.ready;
  syncSessionHeartbeatScheduler(dispatch);
}
